import { apiCall, API_CONFIG } from './api';

export const analyticsAPI = {
  getUserActionLogsCount: async (timeFrame, deviceType) => {
    try {
      const queryParams = new URLSearchParams();
      if (timeFrame) queryParams.append('timeFrame', timeFrame);
      if (deviceType) queryParams.append('deviceType', deviceType);

      const endpoint = `${API_CONFIG.ENDPOINTS.USER_ACTION_LOGS_COUNT}?${queryParams.toString()}`;
      const response = await apiCall(endpoint, {
        method: 'GET',
      });
      return response;
    } catch (error) {
      console.error('Failed to fetch user action logs count:', error);
      throw error;
    }
  },
};
